export default __webpack_public_path__ + "static/stepOneBraceletImg-58251fe2312b4cf5db6164acc7c67262.jpg";